import { sendEventTracking } from '@wukong/haomao/src/request/common';
import { EventTrackingReq } from '@wukong/haomao/src/request/interface/common';

// 功能：埋点上报 ，掉接口，函数参数：埋点名称，埋点参数，是否需要重复打印（默认不重复）
// name `${页面名称}_${事件名}_${l参数}`
export const report = (name: string, params: EventTrackingReq, repeat: boolean = false) => {
  // 如果不需要重复，并且localStorage没有有值， 则上报
  if (!repeat && !localStorage.getItem(name)) {
    localStorage.setItem(name, '1');
    sendEventTracking(params);
    // 需要重复上报
  } else if (repeat) {
    sendEventTracking(params);
  }
};
